export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14734.43f2826d.jpg";